import { FEATURE_FLAGS, type FeatureFlag } from "@/lib/featureFlags";
import { useRoles } from "@/hooks/useRole";

/**
 * Returns true when the flag is enabled OR the current user is a super_admin.
 * Super_admins always see gated surfaces regardless of flag value.
 */
export function useFeatureFlag(flag: FeatureFlag): boolean {
  const { isSuperAdmin } = useRoles();
  return FEATURE_FLAGS[flag] || isSuperAdmin;
}

export function useFeatureFlags(): Record<FeatureFlag, boolean> {
  const { isSuperAdmin } = useRoles();
  return Object.fromEntries(
    (Object.keys(FEATURE_FLAGS) as FeatureFlag[]).map((k) => [
      k,
      FEATURE_FLAGS[k] || isSuperAdmin,
    ]),
  ) as Record<FeatureFlag, boolean>;
}